/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template "model.velocity"
 */

/**
 * THIS Template MUST remain FRAMEWORK INDEPENDENT!! It is used for Angular, Ionic, Node-Express... any JavaScript framework
 */

/* tslint:disable */
import { SiteDetail } from './site-detail.model';


export class Site {
    siteListID: string; // ecf001
    traductions: {[key: string]: SiteDetail}; // ecf001


    // <editor-fold desc="From and To Json Methods" defaultstate="collapsed">
/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template &quot;model-json.velocity&quot;
 */

    /** ---- Generated part from .\ang-man\src\modules\generator\writers\common\templates\model-json.velocity */

    public static mergeJSON(instance: any, data: any): Site {
        if (!data) { return instance; }
        if (data.siteListID != null) {instance.siteListID = data.siteListID; }
        if (data.traductions != null) {
            instance.traductions = {};
            Object.keys(data.traductions).forEach(key => {
                instance.traductions[key] = new SiteDetail().fromJSON(data.traductions[key]); // i6
            });
        }
        return instance; // ir
    }

    public fromJSON(data: any): this { // cbn001
        return Site.mergeJSON(this, data) as any;
    }

    public static mergeJSONFromObject(target: any, object: Site) {
        // TODO: mapping
        return object;
    }

    // toJSON ensures that only class-defined fields are exported.
    public toJSON() {
        return Site.mergeJSONFromObject({}, this);
    }

    // Compares this AppInfo instance with another AppInfo instance, recursively.
    // Transient fields are not considered.
    public equals(other: Site): boolean {
        return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
    }

    /** ---- */


/** end of template &quot;model-json.velocity&quot; */

    // </editor-fold>

}


/** end of template "model.velocity" */
